import { Layout } from '../../libs/layout';

export const InTheNews = {

    itemsPerPage: 24,
    numPages: 0, // Number of pages
    currentPage: 1,
    pagesToDisplay: 5, // Number of pagination items to display
    pages: [], // The pagination items

    init() {
        this.render();
        this.paginationEventListener();
        this.loadMoreEventListener();
    },

    render() {
        this.itemize();
        this.createPages();
        this.createPagination();
        this.updatePagination(this.currentPage);
    },

    /**
     * Itemize the media posts and determine the number of pages
     */
    itemize() {
        let page = 1;
        let self = this;
        $('.media-list .row .col-md-4').each(function(k) {
            if (page > 1) {
                $(this).addClass('d-none');
            }
            $(this).addClass('media-post').addClass(`page-${page}`);
            if ((k % self.itemsPerPage) == (self.itemsPerPage - 1)) {
                page++;
            }
        });

        this.numPages = page-1;
    },

    createPages() {
        for (let i = 1; i <= this.numPages; i++) {
            this.pages.push({
                title: i,
                num: i,
                class: '',
                liClass: this.currentPage === i ? 'active' : ''
            });
        }
    },

    createPagination() {
        let padding = Math.floor(this.pagesToDisplay / 2); // Left and right padding
        let start = this.currentPage - padding - 1;
        let end = this.currentPage + padding;

        if (start < 0) {
            start = 0;
        }

        if (end < this.pagesToDisplay) {
            end = this.pagesToDisplay;
        }

        if (end > this.numPages) {
            start -= this.currentPage % this.pagesToDisplay + 1;
        }

        let pages = this.pages.slice(start, end);

        pages.unshift({
            title: 'Prev',
            num: this.currentPage - 1,
            class: 'page-prev',
            liClass: ''
        });

        pages.push({
            title: 'Next',
            num: this.currentPage + 1,
            class: 'page-next',
            liClass: ''
        });

        let htmlPagination = '';
        for (const [, page] of Object.entries(pages)) {
            htmlPagination += `<li class="page-item ${page.liClass}">
                <a class="page-link ${page.class}" href="#" data-page="${page.num}">${page.title}</a>
            </li>`;
        }

        $('.pagination').empty().html(htmlPagination);
    },

    paginationEventListener() {
        let self = this;
        $('body').on('click', 'a.page-link:not(.page-next, .page-prev)', function(e) {
            e.preventDefault();
            let page = $(this).data('page');
            self.currentPage = page;
            self.display(page);
            self.createPagination();
            self.updatePagination(page);
            self.slideUp();
        });

        $('body').on('click', 'a.page-link.page-next', function(e) {
            e.preventDefault();
            self.currentPage++
            self.display(self.currentPage);
            self.createPagination();
            self.updatePagination(self.currentPage);
            self.slideUp();
        });

        $('body').on('click', 'a.page-link.page-prev', function(e) {
            e.preventDefault();
            self.currentPage--;
            self.display(self.currentPage);
            self.createPagination();
            self.updatePagination(self.currentPage);
            self.slideUp();
        });
    },

    /**
     * Update pagination state and display
     */
    updatePagination(page = 1) {
        if (this.currentPage === 1) {
            $('a.page-link.page-prev').addClass('d-none');
        } else {
            $('a.page-link.page-prev').removeClass('d-none');
        }

        if (this.currentPage >= this.numPages) {
            $('a.page-link.page-next').addClass('d-none');
        } else {
            $('a.page-link.page-next').removeClass('d-none');
        }

        $('.page-item').removeClass('active');
        $(`[data-page="${page}"]`).parent().addClass('active');
    },

    /**
     * Display the current items/media posts
     */
    display(page = 1) {
        $('.media-post').addClass('d-lg-none');
        $(`.media-post.page-${page}`).removeClass('d-none')
            .removeClass('d-lg-none');
    },

    loadMoreEventListener() {
        let self = this;
        $('body').on('click', 'button.load-more', function(e) {
            e.preventDefault();
            $(e.target).find('.default').hide();
            $(e.target).find('.loading').show();
            setTimeout(() => {
                self.currentPage++
                self.display(self.currentPage);
                self.updatePagination(self.currentPage);
                $(e.target).find('.default').show();
                $(e.target).find('.loading').hide();
            }, 150);

        });
    },

    slideUp() {
        Layout.slideToElement('.container .media-list', 200);
    }

}
